import HomeIcon from "@mui/icons-material/Home";
import InfoOutlineIcon from "@mui/icons-material/InfoOutlined";
import { Box, Link, Stack, Typography } from "@mui/material";
import { Button } from "Components/_Shared/Buttons/Button";
import { Flex } from "Components/_Shared/Core/Flex";
import { EmptyPage } from "Components/_Shared/EmptyPage";
import { UnauthenticatedLayout } from "Components/_Shared/Layouts/UnauthenticatedLayout";
import { UnstyledLink } from "Components/_Shared/Routing/UnstyledLink";
import { ANALYZER_EMAIL } from "Infrastructure/Config/constants";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type * as React from "react";

export const Error404Page: React.FunctionComponent = (_) => {
  const { t } = useResource();

  return (
    <UnauthenticatedLayout title={"404"}>
      <EmptyPage
        title={t(Resources.Errors.Error404.Title)}
        subtitle={t(Resources.Errors.Error404.Subtitle)}
        actions={
          <UnstyledLink to="/">
            <Button
              startIcon={<HomeIcon />}
              sx={{
                paddingX: Spacing.XXXL,
                paddingY: Spacing.XL,
              }}
              variant="contained"
              color="primary"
            >
              {t(Resources.Errors.Error404.Home)}
            </Button>
          </UnstyledLink>
        }
      />
    </UnauthenticatedLayout>
  );
};
